// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var loading_icon = '<svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="loading_icon" style="background: none;"><circle cx="50" cy="50" fill="none" stroke="#03417d" stroke-width="8" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(215.934 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>';

jQuery(window).on('load', function() {
	jQuery('html').removeClass('preload');
});

// Sticky header
function sticky_header() {
	if(jQuery(document).scrollTop() >= 90) {
		jQuery('.head').addClass('sticky');
	} else {
		jQuery('.head').removeClass('sticky');
	}
}

jQuery(window).scroll(function() {
	sticky_header();
});

jQuery(document).ready(function() {

	sticky_header();

	var width = jQuery(window).width();

	var benefits = new Swiper('.benefits', {
		slidesPerView: 4,
		spaceBetween: 28,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			550: {
				slidesPerView: 1.2,
			},
			900: {
				slidesPerView: 2,
			},
			1200: {
				slidesPerView: 3,
			},
		},
	});

	var stats = new Swiper('.stats', {
		slidesPerView: 4,
		spaceBetween: 28,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			550: {
				slidesPerView: 1.2,
			},
			900: {
				slidesPerView: 2,
			},
			1200: {
				slidesPerView: 3,
			},
		},
	});

	var testimonials = new Swiper('.testimonials', {
		slidesPerView: 3,
		spaceBetween: 30,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		autoHeight: true,
		breakpoints: {
			600: {
				slidesPerView: 1,
			},
			1200: {
				slidesPerView: 2,
			},
		},
	});

	var similarPosts = new Swiper('.similar-posts__list', {
		slidesPerView: 3,
		spaceBetween: 30,
		breakpoints: {
			600: {
				slidesPerView: 1.2,
			},
			1200: {
				slidesPerView: 2.2,
			},
		},
	});

	function resiNav() {
		jQuery( ".menu" ).before( "<figure></figure>" );
		jQuery('.sub-menu').prepend('<li class="current_parent"><p></p></li>');

		var parents = jQuery('.menu-item-has-children');
		for (var i = 0; i < parents.length; i++) {
			var parentTitle = parents[i].children[0].text;
			var previousParentTitle = parents[i].children[1].children[0].children[0];
			previousParentTitle.innerText = parentTitle;
		}

		jQuery('.menu-header .menu-item-has-children > a').click(function (e) {
			// if (jQuery(window).width() < 920) {
			// 	e.preventDefault();
			// }
			// console.log(jQuery(this)[0].text);
			// jQuery(this).parent().toggleClass('open');
			jQuery(this).next('ul.sub-menu').toggleClass('open');
		});

		jQuery('li.current_parent').click(function() {
			jQuery(this).parent().toggleClass('open');
		});

		jQuery('.resi_button, .resi_over, .menu-header figure').click(function() {
			jQuery('html').toggleClass('js-nav');
			jQuery('ul.sub-menu').removeClass('open')
		});

	}
	resiNav();

	jQuery('*[data-scroll]').click(function() {
		var target = jQuery(this).data('scroll');

		jQuery('html, body').animate({
			 scrollTop: jQuery(target).offset().top - 129
		}, 300);
	});

	// Remove error message form CF7 when input is clicked
	if (jQuery('.wpcf7').length > 0) {
		jQuery('.wpcf7 input, .wpcf7 teaxtarea, .wpcf7 select').click(function(){
			jQuery(this).next('.wpcf7-not-valid-tip').remove();
		});
	}

	if (WPURLS.ajaxurl) {

	}

	document.addEventListener( 'wpcf7mailsent', function( event ) {
		console.log(event);
	}, false );

	// if ( jQuery('body').hasClass('blog') ) {
	// 	jQuery("#recent-sticky").stick_in_parent({offset_top: 40});
	// }

	jQuery('.faqs__list__item__question').click(function() {
		jQuery(this).parent().toggleClass('active');
	});

	jQuery('.testimonials_page__list').isotope({
		// options...
		itemSelector: '.testimonials_page__single',
		masonry: {
		  columnWidth: '.grid-sizer',
		  gutter: 30
		}
	});


});
